import { startRoundTrip } from '@sentinel/web-core';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthCard } from '../AuthCard';

/** On `console.` and `control.` without a session: off to `accounts.`, which signs in and comes
 *  back with a code (ADR 0013). */
export function HostStartPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { org, grant }: { org?: string; grant?: string } = useSearch({ strict: false });

  useEffect(() => {
    void startRoundTrip({ organizationId: org, grantId: grant }).then((started) => {
      if (!started) void navigate({ to: '/login' });
    });
  }, [org, grant]);

  return (
    <AuthCard title={t('accounts.hosts.leaving')} purpose="handoff">
      <div className="indet" role="progressbar" aria-label={t('accounts.hosts.leaving')} />
    </AuthCard>
  );
}
